!function (t, e) {
  if ("object" === typeof exports && "object" === typeof module) module.exports = e(require("react"), require("react-bootstrap"));else if ("function" === typeof define && define.amd) define(["react", "react-bootstrap"], e);else {
    var n = "object" === typeof exports ? e(require("react"), require("react-bootstrap")) : e(t.react, t["react-bootstrap"]);

    for (var r in n) {
      ("object" === typeof exports ? exports : t)[r] = n[r];
    }
  }
}(window, function (t, e) {
  return function (t) {
    var e = {};

    function n(r) {
      if (e[r]) return e[r].exports;
      var o = e[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return t[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }

    return n.m = t, n.c = e, n.d = function (t, e, r) {
      n.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (t) {
      "undefined" !== typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, n.t = function (t, e) {
      if (1 & e && (t = n(t)), 8 & e) return t;
      if (4 & e && "object" === typeof t && t && t.__esModule) return t;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var o in t) {
        n.d(r, o, function (e) {
          return t[e];
        }.bind(null, o));
      }
      return r;
    }, n.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return n.d(e, "a", e), e;
    }, n.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, n.p = "/LukaszNowakPL/react-bootstrap-tools/", n(n.s = 5);
  }([function (e, n) {
    e.exports = t;
  }, function (t, n) {
    t.exports = e;
  }, function (t, e, n) {
    "use strict";

    var r = this && this.__extends || function () {
      var _t = function t(e, n) {
        return (_t = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var n in e) {
            e.hasOwnProperty(n) && (t[n] = e[n]);
          }
        })(e, n);
      };

      return function (e, n) {
        function r() {
          this.constructor = e;
        }

        _t(e, n), e.prototype = null === n ? Object.create(n) : (r.prototype = n.prototype, new r());
      };
    }();

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var o = n(0),
        i = n(0),
        a = n(11),
        s = function (t) {
      function e() {
        var e = null !== t && t.apply(this, arguments) || this;
        return e.displayName = "Glyphicon", e;
      }

      return r(e, t), e.prototype.render = function () {
        var t = this.props,
            e = t.icon,
            n = t.className,
            r = a.getClassName(n);
        return o.createElement("i", {
          className: r
        }, e);
      }, e;
    }(i.PureComponent);

    e.default = s;
  }, function (t, e, n) {
    "use strict";

    var r = this && this.__extends || function () {
      var _t2 = function t(e, n) {
        return (_t2 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var n in e) {
            e.hasOwnProperty(n) && (t[n] = e[n]);
          }
        })(e, n);
      };

      return function (e, n) {
        function r() {
          this.constructor = e;
        }

        _t2(e, n), e.prototype = null === n ? Object.create(n) : (r.prototype = n.prototype, new r());
      };
    }(),
        o = this && this.__assign || function () {
      return (o = Object.assign || function (t) {
        for (var e, n = 1, r = arguments.length; n < r; n++) {
          for (var o in e = arguments[n]) {
            Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
          }
        }

        return t;
      }).apply(this, arguments);
    };

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var i = n(0),
        a = n(0),
        s = n(7),
        u = n(1),
        l = function (t) {
      function e() {
        var e = null !== t && t.apply(this, arguments) || this;
        return e.displayName = "DescribedComponent", e;
      }

      return r(e, t), e.prototype.render = function () {
        var t = this.props,
            e = t.children,
            n = t.description;

        if (n) {
          var r = s.getTooltipProps(this.props),
              a = s.getOverlayTriggerProps(this.props),
              l = i.createElement(u.Tooltip, o({}, r), n);
          return i.createElement(u.OverlayTrigger, o({}, a, {
            overlay: l
          }), e);
        }

        return i.createElement("span", null, this.props.children);
      }, e;
    }(a.PureComponent);

    e.default = l;
  }, function (t, e, n) {
    "use strict";

    var r = this && this.__extends || function () {
      var _t3 = function t(e, n) {
        return (_t3 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var n in e) {
            e.hasOwnProperty(n) && (t[n] = e[n]);
          }
        })(e, n);
      };

      return function (e, n) {
        function r() {
          this.constructor = e;
        }

        _t3(e, n), e.prototype = null === n ? Object.create(n) : (r.prototype = n.prototype, new r());
      };
    }(),
        o = this && this.__assign || function () {
      return (o = Object.assign || function (t) {
        for (var e, n = 1, r = arguments.length; n < r; n++) {
          for (var o in e = arguments[n]) {
            Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
          }
        }

        return t;
      }).apply(this, arguments);
    };

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var i = n(0),
        a = n(0),
        s = n(1),
        u = n(2),
        l = n(13);
    n(15);

    var c = function (t) {
      function e(e) {
        var n = t.call(this, e) || this;
        n.displayName = "AlertBox", n.onClose = function () {
          n.setState({
            shouldClose: !0
          });
        }, n.onEnter = function () {
          var t = n.props.onEnter;
          t && t(n.state.id);
        }, n.onEntering = function () {
          var t = n.props.onEntering;
          t && t(n.state.id);
        }, n.onEntered = function () {
          var t = n.props,
              e = t.onEntered,
              r = t.hideAfter;
          e && e(n.state.id), r && setTimeout(n.onClose, r);
        }, n.onExit = function () {
          var t = n.props.onExit;
          t && t(n.state.id);
        }, n.onExiting = function () {
          var t = n.props.onExiting;
          t && t(n.state.id);
        }, n.onExited = function () {
          var t = n.props.onExited;
          t && t(n.state.id);
        };
        var r = e.id ? e.id : String(new Date().getTime());
        return n.state = {
          shouldOpen: !1,
          shouldClose: !1,
          in: !1,
          id: r
        }, n;
      }

      return r(e, t), e.prototype.componentDidMount = function () {
        this.setState({
          shouldOpen: !0
        });
      }, e.getDerivedStateFromProps = function (t, e) {
        var n = e.shouldOpen,
            r = e.shouldClose;
        return !0 === n ? o({}, e, {
          in: !0,
          shouldOpen: !1
        }) : !0 === r ? o({}, e, {
          in: !1,
          shouldClose: !0
        }) : o({}, e);
      }, e.prototype.render = function () {
        var t = this.props,
            e = t.withIcon,
            n = t.waitingItems,
            r = t.message,
            a = t.withCollapse,
            c = e ? function (t) {
          if (t.withIcon) {
            var e = l.getGlyphiconProps(t);
            return i.createElement(u.default, o({}, e));
          }
        }(this.props) : null,
            p = n ? function (t) {
          var e = t.variant,
              n = t.waitingItems;
          if (n) return i.createElement(s.Badge, {
            variant: e,
            className: "AlertBox__badge"
          }, n);
        }(this.props) : null,
            f = l.getAlertProps({
          props: this.props,
          state: this.state,
          methods: {
            onClose: this.onClose
          }
        }),
            d = i.createElement("div", {
          className: "AlertBox__wrapper"
        }, i.createElement(s.Alert, o({}, f), c, p, r)),
            v = {
          onEnter: this.onEnter,
          onEntering: this.onEntering,
          onEntered: this.onEntered,
          onExit: this.onExit,
          onExiting: this.onExiting,
          onExited: this.onExited
        },
            h = l.getTransitionProps({
          state: this.state,
          methods: v
        });
        return a ? i.createElement(s.Collapse, o({}, h), d) : i.createElement(s.Fade, o({}, h), d);
      }, e;
    }(a.PureComponent);

    e.default = c;
  }, function (t, e, n) {
    t.exports = n(6);
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = n(3);
    e.DescribedComponent = r.default;
    var o = n(9);
    e.DescribedButton = o.default;
    var i = n(2);
    e.Glyphicon = i.default;
    var a = n(4);
    e.AlertBox = a.default;
    var s = n(17);
    e.AlertBoxGroup = s.default;
    var u = n(19);
    e.Avatar = u.default;
    var l = n(22);
    e.addAlert = l.addAlert, e.dismissAlert = l.dismissAlert;
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = n(8);
    e.getOverlayTriggerProps = function (t) {
      var e = {
        overlay: null
      };
      return t.defaultShow && (e.defaultShow = t.defaultShow), t.delay && (e.delay = t.delay), t.trigger && (e.trigger = t.trigger), t.placement && (e.placement = t.placement), e;
    }, e.getTooltipProps = function (t) {
      return {
        id: r.default.defaultTooltipId,
        className: o(r.default.defaultTooltipClassName, t.className)
      };
    };

    var o = function o(t, e) {
      return e ? t + " " + e : t;
    };
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    e.default = {
      defaultTooltipClassName: "Tooltip",
      defaultTooltipId: "tooltip",
      defaultTooltipPlacement: "top"
    };
  }, function (t, e, n) {
    "use strict";

    var r = this && this.__extends || function () {
      var _t4 = function t(e, n) {
        return (_t4 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var n in e) {
            e.hasOwnProperty(n) && (t[n] = e[n]);
          }
        })(e, n);
      };

      return function (e, n) {
        function r() {
          this.constructor = e;
        }

        _t4(e, n), e.prototype = null === n ? Object.create(n) : (r.prototype = n.prototype, new r());
      };
    }(),
        o = this && this.__assign || function () {
      return (o = Object.assign || function (t) {
        for (var e, n = 1, r = arguments.length; n < r; n++) {
          for (var o in e = arguments[n]) {
            Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
          }
        }

        return t;
      }).apply(this, arguments);
    };

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var i = n(0),
        a = n(0),
        s = n(3),
        u = n(10),
        l = n(1),
        c = n(2),
        p = function p(t) {
      var e = u.getButtonProps(t),
          n = t.icon,
          r = t.text,
          a = n ? function (t) {
        var e = u.getGlyphiconProps(t);
        return i.createElement(c.default, o({}, e));
      }(t) : null;
      return i.createElement(l.Button, o({}, e), a, r);
    },
        f = function (t) {
      function e() {
        var e = null !== t && t.apply(this, arguments) || this;
        return e.displayName = "DescribedButton", e;
      }

      return r(e, t), e.prototype.render = function () {
        var t = this.props.description,
            e = p(this.props);

        if (t) {
          var n = u.getDescribedComponentProps(this.props);
          return i.createElement(s.default, o({}, n), e);
        }

        return e;
      }, e;
    }(a.PureComponent);

    e.default = f;
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.getButtonProps = function (t) {
      var e = {};
      return t.name && (e.name = t.name), t.type && (e.type = t.type), (t.active || !1 === t.active) && (e.active = t.active), (t.block || !1 === t.block) && (e.block = t.block), (t.disabled || !1 === t.disabled) && (e.disabled = t.disabled), t.href && (e.href = t.href), t.href && t.hrefNewWindow && (e.target = "_blank"), t.size && (e.size = t.size), t.variant && (e.variant = t.variant), t.buttonClassName && (e.className = t.buttonClassName), t.id && (e.id = t.id), t.onClick && (t.onClickArg || !1 === t.onClickArg || 0 === t.onClickArg || null === t.onClickArg ? e.onClick = function (e) {
        return t.onClick(t.onClickArg, e);
      } : e.onClick = t.onClick), e;
    }, e.getDescribedComponentProps = function (t) {
      var e = {
        children: null
      };
      return t.description && (e.description = t.description), t.className && (e.className = t.className), t.placement && (e.placement = t.placement), t.delay && (e.delay = t.delay), (t.defaultShow || !1 === t.defaultShow) && (e.defaultShow = t.defaultShow), t.trigger && (e.trigger = t.trigger), e;
    }, e.getGlyphiconProps = function (t) {
      var e = {
        icon: t.icon || ""
      };
      return t.iconClassName && (e.className = t.iconClassName), e;
    };
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = n(12);

    e.getClassName = function (t) {
      var e = r.default.defaultComponentClassName;
      return t ? e + " " + t : e;
    };
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    e.default = {
      defaultComponentClassName: "material-icons"
    };
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = n(14);
    e.getAlertProps = function (t) {
      var e = t.props,
          n = t.state,
          r = t.methods,
          o = e.dismissible,
          i = e.closeLabel,
          a = e.variant,
          s = e.className,
          u = {
        id: n.id
      };
      return o && (u.dismissible = o, u.onClose = r.onClose, i && (u.closeLabel = i)), a && (u.variant = a), s && (u.className = s), u;
    }, e.getTransitionProps = function (t) {
      var e = t.state,
          n = t.methods;
      return {
        in: e.in,
        onEnter: n.onEnter,
        onEntering: n.onEntering,
        onEntered: n.onEntered,
        onExit: n.onExit,
        onExiting: n.onExiting,
        onExited: n.onExited
      };
    }, e.getCustomIconType = function (t) {
      return r.default.variantIcons[t] || r.default.defaultIcon;
    }, e.getGlyphiconProps = function (t) {
      var n = t.withIcon,
          o = t.variant,
          i = t.iconClassName,
          a = {
        icon: !0 === n ? e.getCustomIconType(o) : n
      };
      return a.className = i ? r.default.defaultIconClassName.concat(" " + i) : r.default.defaultIconClassName, a;
    };
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    e.default = {
      defaultIcon: "info_outline",
      variantIcons: {
        primary: "info_outline",
        secondary: "info_outline",
        success: "check_circle_outline",
        danger: "highlight_off",
        warning: "error_outline",
        info: "info_outline",
        dark: "info_outline",
        light: "info_outline"
      },
      defaultWrapperClassName: "AlertBox__wrapper",
      defaultIconClassName: "AlertBox__icon"
    };
  }, function (t, e, n) {},, function (t, e, n) {
    "use strict";

    var r = this && this.__extends || function () {
      var _t5 = function t(e, n) {
        return (_t5 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var n in e) {
            e.hasOwnProperty(n) && (t[n] = e[n]);
          }
        })(e, n);
      };

      return function (e, n) {
        function r() {
          this.constructor = e;
        }

        _t5(e, n), e.prototype = null === n ? Object.create(n) : (r.prototype = n.prototype, new r());
      };
    }(),
        o = this && this.__assign || function () {
      return (o = Object.assign || function (t) {
        for (var e, n = 1, r = arguments.length; n < r; n++) {
          for (var o in e = arguments[n]) {
            Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
          }
        }

        return t;
      }).apply(this, arguments);
    };

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var i = n(0),
        a = n(0),
        s = n(18),
        u = n(4),
        l = function (t) {
      function e() {
        var e = null !== t && t.apply(this, arguments) || this;
        return e.displayName = "AlertBoxGroup", e;
      }

      return r(e, t), e.prototype.render = function () {
        var t = this.props.alerts,
            e = this.props.maxAlerts ? this.props.maxAlerts : s.default.maxAlerts;
        return t.length > e ? i.createElement(u.default, o({
          key: t[0].id
        }, t[0], {
          waitingItems: t.length
        })) : i.createElement(i.Fragment, null, t.map(function (t) {
          return i.createElement(u.default, o({
            key: t.id
          }, t));
        }));
      }, e;
    }(a.PureComponent);

    e.default = l;
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    e.default = {
      maxAlerts: 3
    };
  }, function (t, e, n) {
    "use strict";

    var r = this && this.__extends || function () {
      var _t6 = function t(e, n) {
        return (_t6 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var n in e) {
            e.hasOwnProperty(n) && (t[n] = e[n]);
          }
        })(e, n);
      };

      return function (e, n) {
        function r() {
          this.constructor = e;
        }

        _t6(e, n), e.prototype = null === n ? Object.create(n) : (r.prototype = n.prototype, new r());
      };
    }(),
        o = this && this.__assign || function () {
      return (o = Object.assign || function (t) {
        for (var e, n = 1, r = arguments.length; n < r; n++) {
          for (var o in e = arguments[n]) {
            Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
          }
        }

        return t;
      }).apply(this, arguments);
    };

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var i = n(0),
        a = n(0),
        s = n(20),
        u = n(1),
        l = n(2);
    e.AvatarImage = function (t) {
      var e = s.getImageProps(t);
      return i.createElement(u.Image, o({}, e));
    }, e.AvatarIcon = function (t) {
      var e = s.getIconProps(t);
      return i.createElement(l.default, o({}, e));
    };

    var c = function (t) {
      function n() {
        var e = null !== t && t.apply(this, arguments) || this;
        return e.displayName = "Avatar", e;
      }

      return r(n, t), n.prototype.render = function () {
        var t = this.props.src ? i.createElement(e.AvatarImage, o({}, this.props)) : i.createElement(e.AvatarIcon, o({}, this.props)),
            n = s.getWrapperProps(this.props);
        return i.createElement("section", o({}, n), t);
      }, n;
    }(a.PureComponent);

    e.default = c;
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = n(21);
    e.getWrapperProps = function (t) {
      var e = t.className;
      return {
        className: r.default.defaultWrapperClassName + (e ? " " + e : "")
      };
    }, e.getImageProps = function (t) {
      var e = t.src,
          n = t.imageClassName;
      return {
        fluid: !0,
        src: e || "",
        className: r.default.defaultImageClassName + (n ? " " + n : "")
      };
    }, e.getIconProps = function (t) {
      var e = t.icon,
          n = t.iconClassName;
      return {
        icon: e || r.default.defaultIcon,
        className: r.default.defaultIconClassName + (n ? " " + n : "")
      };
    };
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    e.default = {
      defaultIcon: "person",
      defaultWrapperClassName: "Avatar",
      defaultImageClassName: "Avatar__image",
      defaultIconClassName: "Avatar__icon"
    };
  }, function (t, e, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (t) {
        for (var e, n = 1, r = arguments.length; n < r; n++) {
          for (var o in e = arguments[n]) {
            Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
          }
        }

        return t;
      }).apply(this, arguments);
    };

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.addAlert = function (t, e) {
      return t.concat([r({}, e, {
        id: String(new Date().getTime())
      })]);
    }, e.dismissAlert = function (t, e) {
      return t.filter(function (t) {
        return t.id !== e;
      });
    };
  }]);
});